import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { LenderSelect } from '../components/LenderSelect.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props: any): void;
    title: any;
    subtitle?: any;
    currentLender?: string;
    topupValue?: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    currentLender?: string;
    topupValue?: number;
}


export class CurrentLenderTopup extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, currentLender: this.props.currentLender, topupValue: this.props.topupValue};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        if (!this.state.currentLender || !this.state.topupValue) {
            var errors:string[]=[];
            if (!this.state.currentLender) {
                errors.push("Current lender is required");
            }
            if (!this.state.topupValue) {
                errors.push("ome improvement add on amount is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>{this.props.title}</h1>
                {this.props.subtitle && <p>{this.props.subtitle}</p>}
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                        <div className='justify-c' style={{maxWidth: 390}}>
                            <NumberInput
                                id='topupvalue'
                                key='topupvalue'
                                classes={(this.state.hasError && !this.state.topupValue ? "e" : "")}
                                label={<><strong>Top Up amount</strong> sought</>}
                                value={this.props.topupValue}
                                onChange={(e) => { this.setState({topupValue: e.target.value}); this.props.updateLead({topup: e.target.value}); }} />
                        </div>
                        </div>
                        <div className='column2 justify-s'>
                        <div className='justify-c' style={{maxWidth: 390}}>
                            <LenderSelect
                                key='lenders'
                                classes={this.state.hasError && !this.state.currentLender ? "e" : ""}
                                label={<>Who is your current lender?</>}
                                selectedlender={this.props.currentLender}
                                onChange={(e) => { this.setState({currentLender: e.target.value}); this.props.updateLead({currentLender:e.target.value}); }} />

                        </div>
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                         <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
